export default __webpack_public_path__ + "static/media/slider_2.27d8b8fb.jpg";